import { LocalStorage } from "./local_storage";

export {LocalStorage};
export default LocalStorage;
